import React, { useState, useEffect, useMemo, useContext } from "react";
import "ol/ol.css"; //스타일
import { Feature, Map as OlMap, View } from "ol";
import { fromLonLat, get as getProjection } from "ol/proj"; //위경도
import { Vector, XYZ } from "ol/source";

import VectorLayer from "ol/layer/Vector";
import LayerSwitcher from "ol-layerswitcher";
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import { Tile } from "ol/layer";
import { Style, Fill, Stroke, Circle, Icon } from "ol/style";

import { bems_inc_Url } from "../UserPage/ascon/AsconMap";
import pinSvg from "./pin.svg";
import { Point } from "ol/geom";

const baseMap = new Tile({
  //배경지도 레이어
  title: "배경지도",
  displayInLayerSwitcher: false,
  visible: true,
  source: new XYZ({
    url: `${bems_inc_Url}/tiles/base/{z}/{y}/{x}.png`,
  }),
});

const aerialMap = new Tile({
  //배경지도 레이어
  title: "항공지도",
  visible: false,
  source: new XYZ({
    url: `${bems_inc_Url}/tiles/aerial/{z}/{y}/{x}.jpeg`,
  }),
});

// LayerSwitcher 컨트롤 추가
const layerSwitcher = new LayerSwitcher({
  tipLabel: "레이어 전환",
  mouseover: true,
  collapsed: true,
  className: "layer-switcher", // 사용자 정의 클래스 이름
});

const popupElement = document.createElement("div");
popupElement.style.display = "none";
popupElement.id = "popup";
document.body.appendChild(popupElement);

function DetailMap({ checkList }) {
  const [mapObject, setMapObject] = useState(null);

  const poiLayer = useMemo(() => {
    const markerStyle = new Style({
      fill: new Fill({
        color: "rgba(255, 255, 255, 0.2)",
      }),
      stroke: new Stroke({
        color: "#3B11B2",
        width: 2,
      }),
      image: new Circle({
        radius: 12,
        fill: new Fill({
          color: "rgba(255, 255, 255, 0.4)",
        }),
        stroke: new Stroke({ color: "#3B11B2", width: 2 }),
      }),
    });
    let vectorLayer = new VectorLayer({
      source: new Vector({ wrapX: false }),
      style: markerStyle,
    });
    return vectorLayer;
  }, []);

  const pinMarkerLayer = useMemo(() => {
    let markerStyle = new Style({
      image: new Icon({
        //마커 이미지
        opacity: 1, //투명도 1=100%
        scale: 0.1, //크기 1=100%
        src: pinSvg,
      }),
      zindex: 10,
    });

    let markerSource = new Vector();
    let markerLayer = new VectorLayer({
      source: markerSource, //마커 feacture들
      style: markerStyle, //마커 스타일
    });
    return markerLayer;
  }, []);

  useEffect(() => {
    if (mapObject === null) {
      // 지도 중복 생성 막음
      var map = new OlMap({
        target: "mapc",
        view: new View({
          projection: getProjection("EPSG:3857"),
          zoom: 15,
          center: fromLonLat([126.654839, 37.453079]),
          extent: [13982033, 4420002, 14120003, 4575085],
        }),
      });

      map.addLayer(aerialMap);
      map.addLayer(baseMap);
      map.addLayer(poiLayer);
      map.addLayer(pinMarkerLayer);
      map.addControl(layerSwitcher);

      setMapObject(map);

      return () => {
        map.setTarget(undefined);
      };
    }
  }, []);

  useEffect(() => {
    if (checkList && mapObject) {
      const { xpos, ypos } = checkList;
      if (xpos && ypos) {
        const centerCoords = [xpos, ypos]; // 좌표를 EPSG:3857로 변환

        let markerFeature = new Feature({
          geometry: new Point(centerCoords),
        });
        pinMarkerLayer.getSource().clear();
        pinMarkerLayer.getSource().addFeature(markerFeature);
        mapObject.getView().setCenter(centerCoords); // 지도 중심 설정
      }
    }
  }, [checkList, mapObject]); // checkList나 mapObject가 변경될 때마다 실행

  return (
    <div>
      <div className="nowDataMap">
        <div id="mapc" value={mapObject} style={{ height: "400px" }}></div>
      </div>
    </div>
  );
}
export default DetailMap;
